import { formatCompactNumber } from '@ankor-io/common/util/numbers'
import { Heading, Loading, Text } from '@ankor-io/ui-components'

import { useOnboardingHealthQuery } from '@/queries'

type OnboardingKpiKey = 'activeCards' | 'opsAccounts' | 'apaAccounts' | 'users'

const ONBOARDING_STATS: { key: OnboardingKpiKey; label: string }[] = [
  { key: 'activeCards', label: 'Active cards' },
  { key: 'opsAccounts', label: 'Ops accounts' },
  { key: 'apaAccounts', label: 'APA accounts' },
  { key: 'users', label: 'Users' },
]

export const OnboardingHealth = () => {
  const { data, isPending, isError, error } = useOnboardingHealthQuery()

  if (isPending) {
    return (
      <div data-testid="onboarding-health-loading">
        <Loading variant="spinner" />
      </div>
    )
  }

  if (isError) {
    return (
      <Text
        className="text-red-600 dark:text-red-400"
        data-testid="onboarding-health-error"
      >
        Unable to load onboarding health: {error.message}
      </Text>
    )
  }

  return (
    <section
      aria-labelledby="onboarding-health-heading"
      className="space-y-3"
    >
      <Heading level={2}>Onboarding health</Heading>
      <Text className="text-gray-600 dark:text-gray-400">
        Current totals for active cards, ops / APA accounts and platform users.
      </Text>

      <div
        className="grid grid-cols-2 gap-4 md:grid-cols-4"
        data-testid="onboarding-health"
      >
        {ONBOARDING_STATS.map((stat) => (
          <div
            key={stat.key}
            className="rounded-lg border border-gray-200 bg-white p-4 dark:border-gray-700 dark:bg-gray-800"
          >
            <p className="text-xs font-semibold uppercase tracking-widest text-gray-500 dark:text-gray-400">
              {stat.label}
            </p>
            <p className="mt-1 text-2xl font-bold tabular-nums sm:text-3xl">{formatCompactNumber(data[stat.key])}</p>
          </div>
        ))}
      </div>
    </section>
  )
}
